import React from "react";
import "./RemoveAddressModal.css"; // Add your CSS for modal styling
import Icons from "../../../../../../Config/Images";

const RemoveAddressModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="img-icon">
          <img src={Icons.remove_address_icon} alt="" />
        </div>
        <p>Do you want to Remove Address ?</p>
        {/* <p>Are you sure you want to remove this address?</p> */}
        <div className="modal-actions">
          <button className="cancel-btn" onClick={onClose}>No</button>
          <button className="confirm-btn" onClick={onConfirm}>Yes</button>
        </div>
      </div>
    </div>
  );
};

export default RemoveAddressModal;
